import React from 'react';
import {
  shape,
  string,
  bool,
  object
} from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { CheckNearByStore } from './CheckNearByStore';
import { CHECK_NEARBY_STORES } from '../../../constants';

const StoreUnavailable = ({
  itemId,
  location,
  isShipToHomeEligible,
  isAppliance,
  addOnsAssemblyAndMore
}) => {
  const { storeName } = useStore();
  return (
    <>
      <div>
        <span>This item is </span>
        <span className="u__text--danger">unavailable</span>
        <span>{` at ${location.storeName || storeName}`}</span>
      </div>
      {!isAppliance && (
        <div className="fulfillment__sub-title">
          <CheckNearByStore
            itemId={itemId}
            isShipToHomeEligible={isShipToHomeEligible}
            addOnsAssemblyAndMore={addOnsAssemblyAndMore}
          >
            { CHECK_NEARBY_STORES }
          </CheckNearByStore>
        </div>
      )}
    </>
  );
};

StoreUnavailable.propTypes = {
  itemId: string.isRequired,
  isShipToHomeEligible: bool,
  isAppliance: bool,
  location: shape({
    storeName: string,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  addOnsAssemblyAndMore: object
};

StoreUnavailable.defaultProps = {
  isShipToHomeEligible: false,
  isAppliance: false,
  location: {},
  addOnsAssemblyAndMore: null
};

export { StoreUnavailable };
